import { Modal, Button } from 'react-bootstrap';

const AdminModal = ({ showModal, setShowModal, modalTitle, children }) => {
	return (
		<Modal
			fullscreen="sm-down"
			show={showModal}
			onHide={() => setShowModal(false)}
		>
			<Modal.Header closeButton>{modalTitle}</Modal.Header>
			<Modal.Body>{children}</Modal.Body>
		</Modal>
	);
};
export default AdminModal;
